export const passwordRequirementsConst = [
  { text: 'At least 8 characters', type: 'length' },
  { text: 'A lowercase alphabetical character', type: 'lowercase' },
  { text: 'A uppercase alphabetical character', type: 'uppercase' },
  { text: 'A number', type: 'number' },
  { text: 'A special character', type: 'character' },
];
